import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class LandingTextImageBlock extends BaseModel {
  static override constructorName = 'LandingTextImageBlock'

  readonly name = 'text_and_image_block'

  title: string = ''
  text: string = ''
  image: string = ''
  'image_align': string = ''
  'background_image': string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['image', 'background_image'])

      this.image = toCroppedImage(data.image)
      this.background_image = toCroppedImage(data.background_image)
    }
  }
}
